import { getInvalidEmailError } from "../Fields/EmailField.esm.js";
import { getInvalidNameError } from "../Fields/NameField.esm.js";
function getRequiredError(value) {
  if (!value || value.trim() === "") {
    return "Required";
  }
}
function getInvalidPhoneError(value) {
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 10) {
    return "Must be 10 digits";
  }
}
function getNameError(value) {
  const requiredError = getRequiredError(value);
  const invalidNameError = getInvalidNameError(value);
  if (requiredError || invalidNameError) {
    return "Please provide your first and last name";
  }
  const nameParts = value.split(" ").filter((part) => part.length > 0);
  if (nameParts.length < 2) {
    return "Please provide your first and last name";
  }
}
function getEmailError(value) {
  if (getRequiredError(value) || getInvalidEmailError(value)) {
    return "Please provide a valid email address";
  }
}
function getPhoneError(value) {
  if (getRequiredError(value) || getInvalidPhoneError(value)) {
    return "Please provide a valid phone number";
  }
}
function getOrgError(value) {
  if (getRequiredError(value)) {
    return "Please select your organization size";
  }
}
export {
  getEmailError,
  getInvalidPhoneError,
  getNameError,
  getOrgError,
  getPhoneError,
  getRequiredError
};
